module.exports = __webpack_public_path__ + "static/media/icon-status1.58ec8ed2.svg";